import type { NodeDimensions, NodeMatrixEntry } from './types';

export const defaultNodeDimensions: NodeDimensions = {
  nodeWidth: 1, nodeHeight: 1,
};

export const defaultNodeMatrixEntry: NodeMatrixEntry = {
  allocation: {
    owningId: null,
    allocatedNodeId: null,
  },
  position: { x: 0, y: 0 },
};
